<template>
  <div class="network-tabs vm-image-vue-tabs">
    <div class="network-tabs-nav" role="tablist" :aria-label="ariaLabel">
      <button
        v-for="tab in tabsState"
        :key="tab.key"
        type="button"
        class="network-tab"
        :class="{ 'is-active': activeTab === tab.key }"
        :aria-selected="activeTab === tab.key ? 'true' : 'false'"
        @click="activateTab(tab.key)"
      >
        {{ tab.label }}
        <span class="network-tab-count">{{ tab.count }}</span>
      </button>
    </div>

    <div
      v-for="tab in tabsState"
      :key="`panel-${tab.key}`"
      class="network-tab-panel"
      :class="{ 'is-active': activeTab === tab.key }"
      :style="{ display: activeTab === tab.key ? '' : 'none' }"
    >
      <VmImageListResults :initial-data="tab.data" />
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import VmImageListResults from './VmImageListResults.vue'

const props = defineProps({
  ariaLabel: {
    type: String,
    default: 'VM image tabs'
  },
  initialTab: {
    type: String,
    default: ''
  },
  tabs: {
    type: Array,
    default: () => []
  }
})

const activeTab = ref(props.initialTab || props.tabs[0]?.key || '')
const tabsState = ref(props.tabs || [])

function activateTab(tabKey) {
  activeTab.value = tabKey
}

function handleUpdate(event) {
  tabsState.value = event.detail || []
}

onMounted(() => {
  document.addEventListener('scc:vm-image-tabs:update', handleUpdate)
})

onBeforeUnmount(() => {
  document.removeEventListener('scc:vm-image-tabs:update', handleUpdate)
})
</script>
